import moment from 'moment';
import timeTrackingModel from '$$timeTrackingModel';
import projectsModel from '$$projectModel';
import Store from '$$globalStore';
import rights from '../../../components/rights/index';
import dateHelper from '$$dateFormatsHelper';
import ganttFilterHelper from '../../../helpers/gantt_filter';
import multiViewsProjects from '../../../models/multiViewsProjects';
import { ColorCycler } from '../include/helpers';

class TimelogReport {
  initTimelogDataByFilter(currentFilter) {
    const logsData = timeTrackingModel.getLogsByResourceId();
    const tableData = this.prepareTableData(logsData);

    let filterState = currentFilter ? currentFilter.properties : null;
    const hasFilterValues = filterState && Object.values(filterState).some(value => value || ((typeof value === 'string' || Array.isArray(value)) && value.length > 0));

    if (hasFilterValues) {
      const portfolioIds = filterState.portfolio_id;

      if (portfolioIds?.length) {
        const multiviewData = multiViewsProjects.getProjectDataById(portfolioIds[0]);

        filterState = {
          ...filterState,
          gantt_id: [...multiviewData.ganttIDs],
        };
      }
    }

    const filter = filterState && hasFilterValues
      ? ganttFilterHelper.getFilter({ options: filterState }, null)
      : () => true;

    const filteredData = tableData.filter(item => filter(item));

    return filteredData;
  }

  prepareTableData(logs) {
    const tableData = [];

    _.each(logs, logData => {
      const taskData = Store.getters['tasksModel/getTask'](logData.task_id);
      const resourceData = Store.getters['resourcesModel/getResourceById'](logData.resource_id);

      if (!taskData) {
        return;
      }

      const isArchiveProject = !!projectsModel.getArchivedProject(taskData.gantt_id);

      if (isArchiveProject) {
        return;
      }

      const projectData = projectsModel.getProjectDataById(taskData.gantt_id);
      const date = moment(logData.date).startOf('day').toDate();
      let accessRights = rights.project.hasRight(taskData.gantt_id, 'all_tasks');
      const staticFields = rights.project.hasRightSomeOne(taskData.gantt_id, ['static_fields_4_only', 'static_fields']);

      if (!accessRights) {
        accessRights = Store.getters['resourcesModel/isUserAssignedToTask'](taskData.gantt_id, taskData.id);
      }

      if (!accessRights || !staticFields) {
        return;
      }

      tableData.push({
        // for tanstack table
        task: {
          id: logData.task_id,
          name: taskData.text,
        },
        project: {
          id: taskData.gantt_id,
          name: String(projectData.name),
          color: ColorCycler.getColor(taskData.gantt_id),
        },
        user: resourceData,
        table_date: {
          id: new Date(date).getTime(),
          value: webix.Date.dateToStr(dateHelper.getDateFormat())(date),
        },
        table_time: logData.time / 60,
        comment: logData.comment,

        // for gantt filter
        id: logData.id,
        gantt_id: taskData.gantt_id,
        project_name: projectData.name,
        task_id: logData.task_id,
        task_name: taskData.text,
        info_text: taskData.note,
        resource_id: logData.resource_id,
        resource_name: (logData.full_name && logData.full_name.trim()) || logData.resource_name,
        string_date: webix.Date.dateToStr(dateHelper.getDateFormat())(date),
        date: date,
        time: logData.time,
      });
    });

    return tableData;
  }
}

const timelogReport = new TimelogReport();

export default timelogReport;
